<template>
   <dashboard-layout>
       <div class="sh-mainpanel"> 
            <div class="sh-pagetitle">
                <div class="input-group">
                    <div class="input-group">
                        <a href="javascript:;" id="saveOrder" class="btn btn-success float-right" @click="saveOrder()">Opslaan</a>
                    </div>
                </div><!-- input-group -->
                <div class="sh-pagetitle-left">
                <div class="sh-pagetitle-icon"><i class="icon ion-ios-home"></i></div>
                <div class="sh-pagetitle-title"> 
                    <h2>{{ organization.name }}</h2>
                </div><!-- sh-pagetitle-left-title -->
                </div><!-- sh-pagetitle-left -->
            </div><!-- sh-pagetitle -->

            <div class="sh-pagebody">
                <div v-if="loading.msg.length > 0" class="alert alert-info" @click="loading.msg=''">
                    <b>{{loading.msg}}</b>
                    <i class="fa fa-times float-right mt-1"></i>
                </div>
                <div class="row row-sm" v-if="!order_loading">
                    
                        <table class="table">
                            <tr>
                                <th width="100px">Download:</th>
                                <td>
                                    <a target="_blank" :href="'https://zine.all4trade.nl/admin/pdf/download/quote/'+id" class="btn btn-primary mr-2">Offerte</a>
                                    <a target="_blank" :href="'https://zine.all4trade.nl/admin/pdf/download/order/'+id" class="btn btn-success mr-2">Order</a>
                                    <a target="_blank" :href="'https://zine.all4trade.nl/admin/pdf/download/packing_slip/'+id" class="btn btn-warning mr-2">Pakbon</a>
                                    <a target="_blank" :href="'https://zine.all4trade.nl/admin/pdf/download/orderpick/'+id" class="btn btn-warning mr-2">Verzamellijst</a>
                                    <a  target="_blank" 
                                        :href="'https://zine.all4trade.nl/admin/pdf/download/creditinvoice/'+id" 
                                        class="btn btn-danger mr-2" @click="createInvoice($event,order.order_status)" 
                                        v-if="invoice_loading==false && order.type=='CREDITORDER'">Creditfactuur</a>
                                    <a  target="_blank" 
                                        :href="'https://zine.all4trade.nl/admin/pdf/creditinvoice_print/'+id" 
                                        class="btn btn-danger mr-2" @click="createInvoice($event,order.order_status)" 
                                        v-if="invoice_loading==false && order.type=='CREDITORDER'"><i class="fa fa-print"></i> Creditfactuur</a>
                                    <a  target="_blank" 
                                        :href="'https://zine.all4trade.nl/admin/pdf/download/invoice/'+id" 
                                        class="btn btn-danger mr-2" @click="createInvoice($event,order.order_status)" 
                                        v-if="invoice_loading==false && order.type=='ORDER'">Factuur</a>
                                    <a  target="_blank" 
                                        :href="'https://zine.all4trade.nl/admin/pdf/invoice_print/'+id" 
                                        class="btn btn-danger mr-2" @click="createInvoice($event,order.order_status)" 
                                        v-if="invoice_loading==false && order.type=='ORDER'"><i class="fa fa-print"></i> Factuur</a>

                                </td>
                            </tr>
                            <tr>
                                <th>Email:</th>
                                <td>
                                    <button data-toggle="modal" data-target="#emailModal" class="btn btn-primary mr-2" @click="composeEmail('quote')">Offerte</button>
                                    <button data-toggle="modal" data-target="#emailModal" class="btn btn-success mr-2" @click="composeEmail('order')">Order</button>
                                    <button data-toggle="modal" data-target="#emailModal" class="btn btn-warning mr-2" @click="composeEmail('package_slip')">Pakbon</button>
                                    <button class="btn btn-danger mr-2" data-toggle="modal" data-target="#emailModal" @click="composeEmail('creditinvoice')" v-if="order.type=='CREDITORDER' && order.order_status=='CREDITINVOICE'">Creditfactuur</button>
                                    <button class="btn btn-danger mr-2" @click="createInvoice($event,order.order_status)" v-if="order.type=='CREDITORDER' && order.order_status!='CREDITINVOICE'">Creditfactuur</button>
                                    <button class="btn btn-danger mr-2" data-toggle="modal" data-target="#emailModal" @click="composeEmail('invoice')" v-if="order.type=='ORDER' && order.order_status=='INVOICED'">Factuur Mailen</button>
                                    <button class="btn btn-danger mr-2" @click="createInvoice($event,order.order_status)" v-if="order.type=='ORDER' && order.order_status!='INVOICED'">Factuur</button>
                                </td>
                            </tr>
                        </table>
                </div>
                <div class="row row-sm">  
                        <div id="accordion" style="width:100%" class="accordion" role="tablist" aria-multiselectable="true">
                            <div class="card">
                                <div class="card-header" role="tab" id="headingOne">
                                    <h6 class="mg-b-0">
                                        <a class="tx-gray-800 transition" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                                            {{ organization.name }} 
                                        </a>
                                    </h6>
                                </div><!-- card-header -->

                                <div id="collapseOne" class="collapse" role="tabpanel" aria-labelledby="headingOne">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <v-select v-model="order.organization_id" :options="organizations" :reduce="d=>d.id" label="name"></v-select>
                                                <br>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-12">
                                                {{ organization.name }}
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12">
                                                {{ organization.address }} {{ organization.address_number }}
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12">
                                                {{ organization.zipcode }} {{ organization.city }}
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12">
                                                {{ organization.country }}
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-12">
                                                &nbsp;<br>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-12">
                                                Kamer van koophandel nummer: {{ organization.coc }}
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12">
                                                BTW-nummer: {{ organization.vat }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card mg-t-20">
                                <div class="card-header" role="tab" id="headingTwo">
                                    <h6 class="mg-b-0">
                                        <a class="collapsed transition" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                            {{ order.type }}
                                        </a>
                                    </h6>
                                </div>
                                <div id="collapseTwo" class="collapse" role="tabpanel" aria-labelledby="headingTwo">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-4">
                                                <label for="" class="col-form-label">Aangemaakt door:</label>
                                            </div>
                                            <div class="col-md-8">
                                                <span class="help-block">{{ order.creator_name }}</span>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-4">
                                                <label for="" class="col-form-label">Laatst Bewerkt door:</label>
                                            </div>
                                            <div class="col-md-8">
                                                <span class="help-block">{{ order.editor_name }}</span>
                                            </div>
                                        </div>
                                        
                                        <div class="row">
                                            <div class="col-md-4">
                                                <label class="col-form-label">Ordernummer</label>
                                            </div>
                                            <div class="col-md-8">
                                                <span class="help-block">{{ order.id }}</span>
                                            </div>
                                        </div>


                                        <div class="row" v-if="order.order_status!='INVOICED'">
                                            <div class="col-md-4">
                                                <label for="" class="col-form-label">Datum</label>
                                            </div>
                                            <div class="col-md-8">
                                                <span class="help-block"> {{ order.created_at }}</span>
                                            </div>
                                        </div>

                                        <div class="row" v-if="order.order_status=='INVOICED'">
                                            <div class="col-md-4">
                                                <label for="" class="col-form-label">Factuunummer</label>
                                            </div>
                                            <div class="col-md-8">
                                                <span class="help-block"> {{ order.invoice_number }}</span>
                                            </div>
                                        </div>

                                        <div class="row" v-else>
                                            <div class="col-md-4">
                                                <label class="col-form-label">Datum</label>
                                            </div>
                                            <div class="col-md-8" v-if="edit">
                                                    <input type="date" name="order_date" class="form-control" value="@if ( old('order_date', null) != null ) old('order_date')  @else<?php echo date('Y-m-d');?>@endif">

                                            </div>
                                            <div class="col-md-8" v-if="!edit">
                                                <label class="col-form-label">{{ order.order_date}}</label>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-4">
                                                <label class="col-form-label">Orderstatus</label>
                                            </div>
                                            <div class="col-md-8" v-if="edit">
                                                <select name="order_status" class="form-control" v-model="order.order_status">
                                                    <option value="">-- SELECTEER --</option>
                                                    <option value="ENQUIRIE">ENQUIRIE</option>
                                                    <option value="INIT">INIT</option>
                                                    <option value="CREATED">CREATED</option>
                                                    <option value="OPEN">OPEN</option>
                                                    <option value="PICKING">PICKING</option>
                                                    <option value="PENDING">PENDING</option>
                                                    <option value="EXPIRED">EXPIRED</option>
                                                    <option value="CANCELLED">CANCELLED</option>
                                                    <option value="CLOSED">CLOSED</option>
                                                    <option value="SENT">SENT</option>
                                                    <option value="CREDITINVOICE" v-if="order.type=='CREDITORDER'">CREDITINVOICE</option>
                                                    <option value="INVOICED" v-else>INVOICED</option>
                                                    <option value="PAID_BANK">PAID_BANK</option>
                                                    <option value="PAID_CASH">PAID_CASH</option>
                                                    <option value="SHIPPED">SHIPPED</option>
                                                    <option value="RETURNED">RETURNED</option>
                                                    <option value="COMBINE">COMBINE</option>
                                                </select>
                                            </div>
                                            <div class="col-md-8" v-if="!edit">
                                                <label class="col-form-label">{{ order.order_status }}</label>
                                            </div>
                                        </div>

                                            <div class="row" v-if="organization">
                                                <div class="col-md-4">
                                                    <label class="col-form-label">Organizationtype</label>
                                                </div>
                                                <div class="col-lg-8">
                                                    {{ organization.type }}
                                                </div>

                                            </div>

                                            <div class="row">
                                                <div class="col-md-4">
                                                    <label class="col-form-label">Prijsniveau</label>
                                                </div>
                                                <div class="col-lg-8" v-if="organization.price_level==1">
                                                    Standaard
                                                </div>
                                                <div class="col-lg-8" v-if="organization.price_level==2">
                                                    Tussenhandel
                                                </div>
                                                <div class="col-lg-8" v-if="organization.price_level==3">
                                                    Pallet
                                                </div>
                                            </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card mg-t-20">
                                <div class="card-header" role="tab" id="headingThree">
                                    <h6 class="mg-b-0">
                                        <a class="collapsed transition" data-toggle="collapse" data-parent="#accordion" href="#collapseThree" aria-expanded="true" aria-controls="collapseThree">
                                            <i v-if="order.remarks" class="fa fa-exclamation"></i> Opmerkingen
                                        </a>
                                    </h6>
                                </div>
                                <div id="collapseThree" class="collapse" role="tabpanel" aria-labelledby="headingThree">
                                    <div class="card-body" v-if="edit">
                                        <!-- 
                                            TODO add TinyMCE 
                                        -->
                                        <editor
                                           :init="{
                                             height: 500,
                                             menubar: false,
                                             plugins: [
                                               'advlist autolink lists link image charmap print preview anchor',
                                               'searchreplace visualblocks code fullscreen',
                                               'insertdatetime media table paste code help wordcount'
                                             ],
                                             toolbar:
                                               'undo redo | formatselect | bold italic backcolor | \
                                               alignleft aligncenter alignright alignjustify | \
                                               bullist numlist outdent indent | removeformat | help'
                                           }"
                                           v-model="order.remarks"
                                         />
                                    </div>
                                    <div class="card-body" v-if="!edit">
                                        {{ order.remarks }}
                                    </div>
                                </div><!-- collapse -->
                            </div><!-- card -->
                            </div><!-- accordion -->
                            <div class="card bd-primary mg-t-20 p-0" style="width:99%;margin:10px auto">
                                <div class="card-header bg-primary tx-white" role="tab" id="headingThree">
                                    <div class="row">
                                        <div class="col-6">
                                            Orderitems 
                                        </div>
                                        <div class="col-6 text-right">
                                            <span id="price_total_excl">{{formatPrice(totalPriceExcl)}}</span> / <span span id="price_total_incl">{{formatPrice(totalPriceIncl)}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="table-responsive" style="min-height: 500px;"> 
                                        <table class="table dataTable table-striped table-hover">
                                            <thead> 
                                                <tr>
                                                    <th></th>
                                                    <th id="sort_article_number">ARTIKELNUMMER</th>
                                                    <th id="sort_product">PRODUCT</th>
                                                    <th id="sort_amount" width="100px">AANTAL</th> 
                                                    <th></th>
                                                    <th id="sort_box_amount" width="150px">AANTAL IN DOOS</th>
                                                    <th id="sort_pricePer">PRIJS PER</th>
                                                    <th>Laatste prijs</th>
                                                    <th>Productprijzen</th>
                                                    <th id="sort_price">PRIJS</th>
                                                    <th></th>
                                                </tr>
                                                <tr v-if="loading.status">
                                                    <th></th>
                                                    <th></th>
                                                    <th></th>
                                                    <th>
                                                        <div class="" >
                                                            <div class="d-flex pos-relative align-items-center">
                                                                <div style="margin:0px" class="sk-rotating-plane bg-gray-800"></div>
                                                            </div>
                                                        </div>
                                                    </th>
                                                    <th></th>
                                                    <th></th>
                                                    <th></th>
                                                    <th></th>
                                                    <th></th>
                                                    <th></th>
                                                    <th></th>
                                                </tr>
                                                <tr v-if="!loading.status">
                                                    <th></th>
                                                    <th colspan="2">
                                                        <!-- 
                                                            Should display on the orderrow the: product.article_number + product.name_nl
                                                            Should store orderitem.product_id
                                                         -->
                                                        <v-select @input="getPrice()" v-model="orderitem.product_id" :options="products" :reduce="d=>d.id" label="label"></v-select>
                                                        <!-- <select v-model="orderitem.product_id" @change="getPrice()" id="product" class="form-control">
                                                            <option value="0">-- SELECT --</option>
                                                            <option v-for="(p,index) in products" :key="index" :value="p.id">{{p.article_number+' '+p.name_nl}}</option>
                                                        </select> -->
                                                    </th>
                                                    <!-- orderitem.amount -->
                                                    <th><input class="form-control" type="number" @change="computePrice()" @keyup="computePrice()" min="1" v-model="orderitem.show_amount" value="1" id="productAmount"></th>
                                                    <!-- 
                                                        amount factor to caluclate the actual amount 
                                                        the factor and the amount combined shoud result to the actual amount as described in the comments of the  createOrderItem method.
                                                    -->
                                                    <th>
                                                        <select class="form-control" v-model="orderitem.amount_factor" @change="computePrice()">
                                                            <option value="pieces">Stuks</option> <!-- piece -->
                                                            <option value="boxes" selected>Dozen</option> <!-- boxes -->
                                                            <option value="pallet">Pallet</option> <!-- pallet -->
                                                        </select>
                                                    </th>

                                                    <th id="product_box_amount">
                                                        <!-- 
                                                            Should display the number of items in a box (product.box_amount) of the selected product
                                                            doesnt need to be stored
                                                        -->
                                                        {{product_selected.box_amount}}
                                                    </th>
                                                    <th id="product_pricePer">
                                                        <!-- 
                                                            Should store to
                                                            orderitem.pricePer
                                                         -->
                                                        <select class="form-control" v-model="orderitem.pricePer" v-if="product_selected.id">
                                                            <option :value="product_selected.purchase_price" disabled>{{ formatPrice(product_selected.purchase_price) }} Inkoop</option>
                                                            <option :value="lastPrice" v-if="lastPrice">{{ formatPrice(lastPrice) }} Laatste prijs</option>
                                                            <option :value="product_selected.price_pallet">{{ formatPrice(product_selected.price_pallet) }} Pallet</option>
                                                            <option :value="product_selected.price_tussenhandel">{{ formatPrice(product_selected.price_tussenhandel) }} Tussenhandel</option>
                                                            <option :value="product_selected.price_standaard">{{ formatPrice(product_selected.price_standaard) }} Standaard</option>
                                                        </select>

                                                    </th>
                                                    <th>
                                                        <span v-if="orderitem.last_price">{{ formatPrice(orderitem.last_price) }}</span>
                                                    </th>
                                                    <th></th>
                                                    <th><span v-if="product_selected.id">{{ formatPrice(orderitem.price) }}</span></th>
                                                        <!-- 
                                                            Should calculate the total price (actual orederitem.amount * orderitem.pricePer)
                                                         -->
                                                    <th>
                                                        <a @click="createOrderItem()" href="javascript:;" id="addProduct" class="btn btn-primary"><i class="fa fa-plus"></i></a>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody id="productitems">
                                                <!-- 
                                                    TODO
                                                    SHOW ALL EXISTING ORDERITEMS
                                                    ADD EDIT BUTTON PER ROW LIKE CASASOFT
                                                 -->
                                                <tr v-for="(item ,index) in order.order_items" :key="index">
                                                    <td></td>
                                                    <td colspan="2">
                                                        <span  v-if="!item.edit">
                                                            {{item.product.article_number+' '+item.description}}
                                                            ( {{ item.product.weight }} {{ item.product.weight_unit }} )
                                                        </span>
                                                        <!-- <v-select v-else @input="getEditPrice(item)" v-model="item.product_id" :options="products" :reduce="d=>d.id" label="label"></v-select> -->
                                                        <input v-else type="text" v-model="item.description" class="form-control">
                                                    </td> 
                                                    <td>
                                                        <span v-if="!item.edit">{{item.amount}}</span>
                                                        <input v-else class="form-control" type="number" @change="computeEditPrice(item.id)" @keyup="computeEditPrice(item.id)" v-model="item.amount" />
                                                    </td> 
                                                    <td>Stuks</td>
                                                    <!-- <td>{{item.skuID}}</td> -->
                                                    <!-- <td></td> -->
                                                    <td>
                                                        <span v-if="JSON.parse(item.level_price)">{{ JSON.parse(item.level_price).box_amount }}</span>
                                                    </td>
                                                    <td>
                                                        <span v-if="!item.edit">{{ formatPrice(item.pricePer) }}</span>
                                                        <input v-else type="number" v-model="item.pricePer" @change="computeEditPrice(item.id)" @keyup="computeEditPrice(item.id)" class="form-control" />
                                                    </td>
                                                    <td><span v-if="item.last_price">{{formatPrice(item.last_price)}}</span><span v-else>Onbekend</span></td>
                                                    <td>
                                                        <span v-if="JSON.parse(item.level_price)">Pallet: {{ formatPrice(JSON.parse(item.level_price).price_pallet) }}<br></span>
                                                        <span v-if="JSON.parse(item.level_price)">Tussenhandel: {{ formatPrice(JSON.parse(item.level_price).price_tussenhandel) }}<br></span>
                                                        <span v-if="JSON.parse(item.level_price)">Winkel: {{ formatPrice(JSON.parse(item.level_price).price_standaard) }}<br></span>
                                                    </td>
                                                    <td>{{formatPrice(item.price)}}</td>
                                                    <td>
                                                        <div class="btn-group">
                                                        <button v-if="!item.edit" @click="setEdit(item.id)" class="btn btn-warning"><i class="fa fa-edit"></i></button>
                                                        <button v-if="item.edit && !item.loading" @click="updateitem(item)" class="btn btn-success"><i class="fa fa-check"></i></button>
                                                        <button v-if="item.loading" class="btn btn-warning"><i class="fa fa-refresh"></i></button>
                                                        <button @click="deleteItem(item.id)" class="btn btn-danger"><i class="fa fa-trash"></i></button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div><!-- card -->
                        
                </div>
            </div> 
       </div> 
       <div id="emailModal" class="modal fade">
            <div style="max-width: 700px;width: 700px;left:0" class="modal-dialog modal-dialog-vertical-center" role="document">
                <div class="modal-content bd-0 tx-14">
                    <div class="modal-header pd-y-20 pd-x-25">
                        <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">VERSTUUR EMAIL</h6>
                        <button id="close" type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body pd-25">
                        <div class="form-group">
                                <label for="">Emailadres</label>
                                <input type="text" class="form-control" v-model="email.address">
                            </div>
                            <div class="form-group">
                                <label for="">Onderwerp</label>
                                <input type="text" class="form-control" v-model="email.subject">
                            </div>
                            <div class="form-group">
                                <label for="">Bericht</label>
                                <editor
                                   :init="{
                                     height: 500,
                                     menubar: false,
                                     plugins: [
                                       'advlist autolink lists link image charmap print preview anchor',
                                       'searchreplace visualblocks code fullscreen',
                                       'insertdatetime media table paste code help wordcount'
                                     ],
                                     toolbar:
                                       'undo redo | formatselect | bold italic backcolor | \
                                       alignleft aligncenter alignright alignjustify | \
                                       bullist numlist outdent indent | removeformat | help'
                                   }"
                                   v-model="email.body"
                                 />
                            </div>
                            <div class="form-group">
                            <button @click="sentEmail()" class="btn btn-success">Verstuur</button>
                            </div>
                    </div> 
                </div>
            </div><!-- modal-dialog -->
        </div> 
   </dashboard-layout>
   
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
import dashboardLayout from '../layouts/dashboard_layout'
import { mapState } from 'vuex'
export default {
    name:'edit_order',
    props:{
        id:{
          required:true
        }
    },
    components:{
        dashboardLayout,
        'editor': Editor,
    },
    computed:{
        ...mapState({
            loading:(state)=>state.loading,
            endpoint:(state)=>state.endpoint,
        }),
        organization : function(){
            return this.order.organization;
        },
        pdfUrls : function(){
            var api_token = localStorage.getItem('api_token');
            return {
                'quote'         : this.endpoint+'vue/pdf/quote/orderid/'+this.order.id+'?api_token='+api_token,
                'enquirie'      : this.endpoint+'vue/pdf/enquirie/orderid/'+this.order.id+'?api_token='+api_token,
                'order'         : this.endpoint+'vue/pdf/order/orderid/'+this.order.id+'?api_token='+api_token,
                'package_slip'  : this.endpoint+'vue/pdf/package_slip/orderid/'+this.order.id+'?api_token='+api_token,
                'invoice'       : this.endpoint+'vue/pdf/invoice/orderid/'+this.order.id+'?api_token='+api_token,
                'creditinvoice' : this.endpoint+'vue/pdf/creditinvoice/orderid/'+this.order.id+'?api_token='+api_token,
                'invoice_print'       : this.endpoint+'vue/pdf/invoice_print/orderid/'+this.order.id+'?api_token='+api_token,
                'creditinvoice_print' : this.endpoint+'vue/pdf/creditinvoice_print/orderid/'+this.order.id+'?api_token='+api_token,
            };
        },
        totalPriceExcl : function(){
            if(this.order.order_items){
                var total = 0;
                this.order.order_items.forEach(function(item){
                    total += parseFloat(item.price);
                });
                return total;
            }
            return 0.00;
        },
        totalPriceIncl : function(){
            if(this.organization){
                if(this.organization.use_vat==1){
                    if(this.order.order_items){
                        var total = 0;
                        this.order.order_items.forEach(function(item){
                            var price = parseFloat(item.price);
                            var productvat = parseFloat(item.vat);
                            var tvat = price * (1+(productvat/100));
                            var vat = tvat - price;
                            total += vat;
                        });
                        return (total + this.totalPriceExcl) * 1.21;
                    }
                }
            }
            return 0;
        },
        lastPrice : function(){
            return this.price_last;
        },
    },
    data(){
        return {
            invoice_loading: false,
            organizations:[],
            order_loading: true,
            edit : true,
            orderitem:{
                order_id: this.id,
                product_id:0,
                description:'',
                amount:1,
                amount_unit:'box',
                amount_factor:'boxes',
                price:0,
                pricePer:0,
                vat:0,
                last_price:0,
            },
            resetOrderItemBackup:null,
            order:{
                organization:{
                    name : ''
                },
            },
            orderitems:[],
            products : [],
            product_selected : {},
            email:{address:'',subject:'',body:''},
            emailType:'',
            total:{
                withVat:0,withoutVat:0
            },
            price_last: false,
        }
    },
    methods : {
        composeEmail(type){
            this.emailType=type;
            var translation = {
                'quote'         : 'offerte',
                'enquirie'      : 'offerte',
                'order'         : 'order',
                'package_slip'  : 'pakbon',
                'invoice'       : 'factuur',
                'creditinvoice' : 'creditfactuur',
            };
            this.email.address = this.order.organization.email;
            this.email.subject = translation[type] + ' ' + this.id;
            this.email.body = 'Beste '+this.order.organization.name+',<br><br> Bijgaand treft u de beloofde '+translation[type]+'.<br><br> Met vriendelijke groet,<br> All4Trade';
        },
        sentEmail(){
            // TODO
            // API route:
            // POST /api/v1/vue/email/{type}/orderid/{id}
            // if succesfull close model else show error

            this.$store.dispatch('post',{
                details:this.email,
                endpoint:this.endpoint+'vue/email/'+this.emailType+'/orderid/'+this.id
            })
            .then((data)=>{
                if(!data.data.error){
                    this.$store.state.loading.msg="Email verzonden.";
                    window.$("#close").click();
                    this.email={address:'',subject:'',body:''};
                }
                else{
                    this.$store.state.loading.msg="Email kon niet verzonden worden.";
                }
            })
            .catch((error)=>{
                console.log(error.request);
                this.$store.state.loading.msg="Email kon niet verzonden worden.";
            });
        },
        createInvoice(e,status){
            if(status != 'INVOICED' && status != 'CREDITINVOICE'){
                e.preventDefault();
                // TODO
                // ask for confirmation to create an invoice
                if(!confirm('Weet je zeker dat je deze order om wilt zetten naar een factuur?')){ return false; }
            }

            this.invoice_loading = true;

            if(this.order.type=='CREDITORDER'){
                this.order.order_status = 'CREDITINVOICE';
            }else{
                this.order.order_status = 'INVOICED';
            }
            
            // update order
            // PUT /api/v1/vue/order/{order_id}
            this.$store.dispatch('post',{
                details:this.order,
                endpoint:this.endpoint+'vue/order/'+this.id+'/update'
            })
            .then((data)=>{
                console.log(data);
                this.invoice_loading = false;
            })
            .catch((error)=>{
                console.log(error.request);
            });
        },
        
        saveOrder : function(){
            // TODO
            // SAVE ORDER
            // update order
            // PUT /api/v1/vue/order/{order_id}
            
            console.log('order', this.order);

            this.$store.dispatch('post',{
                details:this.order,
                endpoint:this.endpoint+'vue/order/'+this.id+'/update'
            })
            .then((data)=>{
                if(!data.data.error){
                    this.$store.state.loading.msg="Wijzigingen order opgeslagen.";
                }
                else{
                    this.$store.state.loading.msg="Orderwijzigingen konden niet opgeslagen worden";
                }
            })
            .catch((error)=>{
                this.$store.state.loading.msg="Orderwijzigingen konden niet opgeslagen worden";
                console.log(error.request);
            });
        },

        getAmount(item){
            window.console.log(item);
        },
        createOrderItem(){
            this.$store.state.loading.status=true;
            this.orderitem.product_selected = JSON.stringify(this.product_selected);
            console.log('ORDERITEM',this.orderitem);
            // return false;
            this.$store.dispatch('post',{
                details:this.orderitem,
                endpoint:this.endpoint+"vue/orderitems"
            })
            .then((data)=>{
                console.log(data); 
                this.$store.state.loading.msg='Orderitem toegevoegd';
                this.$store.state.loading.status=false;
                if(this.orderitem.last_price){
                    data.data['last_price'] = this.orderitem.last_price;
                }
                this.orderitem=JSON.parse(this.resetOrderItemBackup); 
                this.product_selected={};
                this.order.order_items.unshift(data.data);

                setTimeout(()=>{
                    this.$store.state.loading.msg='';
                },3000);
            })
            .catch((error)=>{
                console.log(error.request);
                this.$store.state.loading.status=false;
            });
        },
        computePrice(){
            if(this.orderitem.amount_factor == 'pieces'){
                this.orderitem.amount= parseFloat(this.orderitem.show_amount);
            }else if(this.orderitem.amount_factor == 'boxes'){
                this.orderitem.amount= parseFloat(this.orderitem.show_amount) * parseFloat(this.product_selected.box_amount);
            }else if(this.orderitem.amount_factor == 'pallet'){
                this.orderitem.amount= parseFloat(this.orderitem.show_amount) * parseFloat(this.product_selected.box_amount) * parseFloat(this.product_selected.pallet_amount);
            }
            this.orderitem.price = this.orderitem.amount * this.orderitem.pricePer;
        },
        computeEditPrice(id){
            this.order.order_items=this.order.order_items.map((d)=>{
                if(d.id == id){ 
                    d.price=parseFloat(d.pricePer) * parseFloat(d.amount);
                }
                return d;
            });
        },
        updateitem(data){
            this.$store.dispatch('post',{details:data,endpoint:this.endpoint+'vue/orderitems/'+data.id+'/update'})
            .then((data)=>{
                console.log(data); 
            })
            .catch((error)=>{
                console.log(error.request); 
            });
            this.setEdit(data.id);
        },
        setEdit(id){
            this.order.order_items=this.order.order_items.map((d)=>{
                if(d.id == id){
                    console.log(d);
                    d.edit=d.edit ? false:true; 
                }
                return d;
            });
        },
        toggleLoading(id){
            this.order.order_items=this.order.order_items.map((d)=>{
                if(d.id == id){
                    d.loading=d.loading ? false:true; 
                }
                return d;
            });
        },
        getLastPrice(){
            if(this.product_selected){
                this.price_last = 'Aan het opzoeken...';
                this.$store.dispatch('get',this.endpoint+'vue/lastprice/organization/'+this.order.organization_id+'/product/'+this.product_selected.id)
                .then((data)=>{ 
                    this.orderitem.last_price = 0;
                    if(data.data.price>0){
                        this.price_last = parseFloat(data.data.price);
                        this.orderitem.pricePer = this.price_last;
                        this.orderitem.last_price = this.price_last;
                    }else{
                        this.price_last = false;
                        if(this.organization.price_level==1){
                            this.orderitem.pricePer         = this.product_selected.price_standaard;
                        }

                        if(this.organization.price_level==2){
                            this.orderitem.pricePer         = this.product_selected.price_tussenhandel;
                        }
                        
                        if(this.organization.price_level==3){
                            this.orderitem.pricePer         = this.product_selected.price_pallet;
                        }
                    }


                    console.log('laatste prijs: ', this.price_last, parseFloat(data.data.price));
                })
                .catch((error)=>{
                    console.log(error.request);
                });
            }
        },
        // getEditPrice(item){  
        //     var product=this.products.find((d)=>d.id == item.product_id);
             

        //     this.toggleLoading(item.id); 
        //     this.$store.dispatch('get',this.endpoint+'vue/order/productprices/organization/'+this.order.organization_id+'/product/'+item.product_id)
        //     .then((data)=>{ 
        //         this.order.order_items=this.order.order_items.map((d)=>{
        //             if(d.id == item.id){ 
        //                 d.pricePer=data.data;
        //                 d.price=parseFloat(d.pricePer) * parseFloat(d.amount);
        //                 d.description=product.name_nl;
        //                 d.vat=product.vat;
        //             }
        //             return d;
        //         });
                
        //         this.toggleLoading(item.id);
        //     })
        //     .catch((error)=>{
        //         console.log(error.request);
        //         this.toggleLoading(item.id);
        //     });
        // },
        getPrice(){ 
            if(this.orderitem.product_id == 0){
                return false;
            }
            var product=this.products.find((d)=>d.id == this.orderitem.product_id);
            this.product_selected=product;

            if(this.organization.price_level==1){
                this.product_selected.price_per = this.product_selected.price_standaard;
                this.orderitem.pricePer         = this.product_selected.price_standaard;
            }

            if(this.organization.price_level==2){
                this.product_selected.price_per = this.product_selected.price_tussenhandel;
                this.orderitem.pricePer         = this.product_selected.price_tussenhandel;
            }

            if(this.organization.price_level==3){
                this.product_selected.price_per = this.product_selected.price_pallet;
                this.orderitem.pricePer         = this.product_selected.price_pallet;
            }

            this.getLastPrice();

            this.$store.state.loading.status=true;
            this.$store.dispatch('get',this.endpoint+'vue/order/productprices/organization/'+this.order.organization_id+'/product/'+this.orderitem.product_id)
            .then((data)=>{ 
                console.log(data, 'PRODUCT', product);
                this.orderitem.pricePer=data.data;
                this.orderitem.price=parseFloat(this.orderitem.pricePer) * parseFloat(this.orderitem.amount);
                this.orderitem.description=product.name_nl + ' (' + product.weight + ' ' + product.weight_unit+')';
                this.orderitem.vat=product.vat;
                this.$store.state.loading.status=false;
                this.computePrice();
            })
            .catch((error)=>{
                console.log(error.request);
                this.$store.state.loading.status=false;
            });
        },
        deleteItem(id){
            if(!confirm('Are you sure you want to delete this item')){
                return false;
            }
            this.order.order_items=this.order.order_items.filter((d)=> d.id != id);
            
            this.$store.dispatch('post',{details:'',endpoint:this.endpoint+'vue/orderitems/'+id+'/delete'})
            .then((data)=>{
                console.log('delete',data); 
            })
            .catch((error)=>{
                console.log(error.request);
            });

        }
    },
    created(){
        this.resetOrderItemBackup=JSON.stringify(this.orderitem); // backing up the initial state of orderitem so we can reuse this state after creating an order
        this.orderitem.order_id=this.$route.params.id;

        // GETTING PRODUCTS
        this.$store.dispatch('get',this.endpoint+'vue/order/products')
        .then((data)=>{
            // console.log('products',data);
            data.data=data.data.map((d)=>{
                d.label=d.article_number +' '+d.name_nl + ' (' + d.weight + ' ' + d.weight_unit+')';
                d.edit=false;
                d.loading=false;

                this.total.withVat+=d.price;
                this.total.withoutVat+=d.price;
                
                return d;
            });
            this.products = data.data;
        })
        .catch((error)=>{
            console.log(error.request);
        });

        //GETTING ORDER
        //this.$store.state.loading.status=true;
        this.$store.dispatch('get',this.endpoint+'vue/order/'+this.id)
        .then((data)=>{
            console.log('order',data.data);
            this.order = data.data;
            setTimeout(()=>{
                window.$("#dataTable").DataTable();
            },500);
            this.order_loading = false;
            this.$store.state.loading.status=false;
        })
        .catch((error)=>{
            console.log(error.request);
            this.$store.state.loading.status=false;
        });

        // GET organizations
        
        this.$store.dispatch('get',this.endpoint+'vue/order/organizations')
        .then((data)=>{
            console.log(data);
            this.organizations=data.data; 
        })
        .catch((error)=>{
            console.log(error.request);
        })
    }
}
</script>
<style>
    #orderForm{
        width: 100%;
    }
    select.form-control{
        background: white;
        width: 70px;
    }
    .fa-refresh{
        animation: roll .5s linear infinite;
    }

    @keyframes roll {
        0%{
            transform: rotate(0deg);
        }
        100%{
            transform: rotate(360deg);
        }
    }

    .table thead > tr > th, .table tbody > tr > th, .table tbody > tr > td, .table thead > tr > th:hover, .table tbody > tr > td:hover{
        border-top: 0px !important;
        border-bottom: 0px !important;
    }
</style>